var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicyHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1983",
    "data-name": "Group 1983",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.313,
    height: 27.583,
    viewBox: "0 0 43.313 27.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1441",
    "data-name": "Rectangle 1441",
    width: 43.313,
    height: 27.583,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1982",
    "data-name": "Group 1982",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48468",
    "data-name": "Path 48468",
    d: "M17.925,20.079h-.033a.706.706,0,0,1-.63-.471L12.354,5.658,9.4,13.2a.7.7,0,0,1-.654.447H0V12.235H8.262l3.471-8.854a.706.706,0,0,1,1.32.024l4.958,14.1L22.692,7.325a.7.7,0,0,1,1.235-.079l3.442,5.514h5.538v1.408H26.979a.7.7,0,0,1-.6-.333L23.425,9.1l-4.86,10.569a.707.707,0,0,1-.64.409",
    transform: "translate(0 4.048)",
    fill: "#4cbd01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48469",
    "data-name": "Path 48469",
    d: "M20.324,27.583a3.407,3.407,0,0,1-2.139-.749c-.383-.312-.773-.63-1.159-.952-1.111-.921-2.189-1.851-3.209-2.764l.94-1.049c1.006.9,2.072,1.822,3.169,2.731.381.316.766.63,1.144.937a2,2,0,0,0,2.51,0C30.237,18.717,35.4,12.682,35.4,9.594c0-5.319-4.377-8.186-8.49-8.186H26.9A7.884,7.884,0,0,0,20.89,4.66a.705.705,0,0,1-1.17,0,7.9,7.9,0,0,0-6.011-3.24h0A8.61,8.61,0,0,0,5.991,6L4.718,5.4A9.156,9.156,0,0,1,8.6,1.337,10.752,10.752,0,0,1,13.7.012h.01A8.948,8.948,0,0,1,20.3,3.14,8.937,8.937,0,0,1,26.9,0h.01c4.8,0,9.891,3.359,9.9,9.592,0,2.284-1.863,5.353-5.7,9.385a97.117,97.117,0,0,1-8.635,7.853,3.406,3.406,0,0,1-2.143.754",
    transform: "translate(6.506 0)",
    fill: "#3d3d3d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyHealth);
export default __webpack_public_path__ + "static/media/policy-health.c46199811db081105bfd8f2a2afca78d.svg";
export { ForwardRef as ReactComponent };